var customSearch = (function() {
  var mainDomain =
    window.location.origin.indexOf("dev") >= 0
      ? "https://www.dev.ring.com"
      : window.location.origin.indexOf("qa") >= 0
      ? "https://www.qa.ring.com"
      : "https://ring.com";

  var CONFIG = {
    redirections: [
      { value: "/pages/warranty", terms: ["warranty"] },
      {
        value: "/pages/exclusive-discounts",
        terms: [
          "military discount",
          "millitary discount",
          "military discounts",
          "miltary discount",
          "military",
          "first responder discount",
          "first responder discounts",
          "first responders discount",
          "teacher discount",
          "senior discount",
          "student discount",
          "police discount",
          "veterans discount",
          "veteran discount",
          "health care discount",
          "healthcare discount",
          "law enforcement discount",
          "law enforcement discounts",
          "medical discount",
          "nurse discount",
          "senior discounts",
          "veteran"
        ]
      },
      {
        value: "/collections/wireless-doorbell-cameras",
        terms: [
          "wireless doorbell",
          "wireless ring door bell",
          "wireless ring doorbell",
          "wireless video doorbell"
        ]
      },
      { value: "/pages/oss", terms: ["software"] },
      {
        value: mainDomain + "/users/sign_in",
        terms: ["my devices", "my account", "account", "password", "history", "login", "log in"]
      },
      {
        value: mainDomain + "/gettheapp",
        terms: ["download", "download app", "app", "ring app"]
      },
      {
        value: "/pages/doorbell-cameras#/compare_anchor",
        terms: [
          "compare",
          "compare doorbells",
          "compare ring doorbell",
          "compare video doorbells"
        ]
      },
      {
        value: "/pages/security-cameras",
        terms: [
          "arlo",
          "logitech",
          "logitech webcam",
          "logitech brio",
          "webcam",
          "webcams",
          "web cam",
          "web cams",
          "logitech c920",
          "c920",
          "blink",
          "nest",
          "google",
          "razer kiyo",
          "google home",
          "blink xt2",
          "canon g7x",
          "canon camera",
          "canon",
          "nikon"
        ]
      },
      {
        value: mainDomain + "/account/order-history",
        terms: ["receipt", "my order", "invoice"]
      },
      { value: "/products/video-doorbell-3", terms: ["ring door bell 3"] },
      {
        value: "/collections/offers",
        terms: ["sale", "discount", "discounts", "sales", "deals", "package deals", "on sale", "sale items"]
      },
      { value: "/pages/privacy", terms: ["privacy notice", "privacy"] },
      { value: "/products/security-system-alarm-10", terms: ["4k11 s70enc"] },
      { value: mainDomain + "/account/activity", terms: ["delete history"] },
      {
        value: "/pages/protect-plans",
        terms: [
          "basic plan",
          "purchase plans",
          "video plan",
          "basic",
          "ring basic",
          "membership",
          "basic protection plan",
          "video protection plan",
          "set up protection plan",
          "monthly protection plan",
          "ring doorbell protection plans",
          "recording protection plan",
          "purchase ring protection plan",
          "cloud",
          "pay bill",
          "billing",
          "trial",
          "monthly fees",
          "protect plus trial",
          "unsubscribe",
          "cancel plan",
          "plan",
          "plans",
          "protect",
          "protection",
          "protect plan",
          "protect plans",
          "protection plan",
          "ring plan",
          "ring plans",
          "ring protect",
          "ring protect plan",
          "ring protect plans",
          "ring protection plan",
          "protection plans",
          "subscribe",
          "plan básico",
          "plan de video",
          "básico",
          "membresía",
          "plan de protección",
          "plan de protección de video",
          "plan de protección mensual",
          "plan de protección de grabación",
          "nube",
          "factura de pago",
          "prueba",
          "facturación",
          "tarifas mensuales",
          "cancelar suscripción",
          "membresías y suscripciones",
          "plan de base",
          "plan vidéo",
          "de base",
          "ring basic",
          "adhésion",
          "plan de protection",
          "plan de protection vidéo",
          "plan de protection mensuel",
          "plan de protection d'enregistrement",
          "achat de plan de protection de l'anneau",
          "payer la facture",
          "essai",
          "facturation",
          "frais mensuels",
          "désabonnement",
          "protection et essai",
          "essai gratuit",
          "monthly",
          "set up plan",
          "protecci n plan",
          "is there a monthly fee",
          "subcription",
          "cloud video recording",
          "protect plus",
          "ring protect plus",
          "ring protection",
          "protection plus",
          "protect plus plan",
          "ring protection plans",
          "ring protect plus plan",
          "ring protection plus",
          "protective plan",
          "protecting plan",
          "protect plan plus",
          "protection plus plan",
          "protective plans",
          "plan protection",
          "video protection",
          "protect subscriber",
          "ring protect service",
          "subscribe ring protect",
          "subscribe to ring protect",
          "protected plan",
          "plan protect",
          "protecting plans",
          "ring protect trial",
          "protection plan plus",
          "protection pla",
          "protect pla",
          "protections plans",
          "ring protect free plan",
          "a protection plan",
          "subscribe for protection plan",
          "protection plan plans",
          "plus protect plan",
          "protections plan",
          "protect plus",
          "ring protect plus",
          "protection service",
          "protected",
          "protect plus plans",
          "protection plan s",
          "ring video protection",
          "ring protection plus plan",
          "ring protection",
          "protectation plan",
          "protect ring",
          "plans protection",
          "protection plans plus",
          "but protect plan",
          "protecting",
          "plus protection plan",
          "protected by ring",
          "protectio",
          "protection pan",
          "ring protect pla",
          "protecte plan",
          "subscribe to protection",
          "protection plus pla",
          "protected plans",
          "add protect plus",
          "what is ring protection",
          "subscribe for protection plans",
          "protection and",
          "ring protect plus plan",
          "protections",
          "rings protecting plan",
          "protect video",
          "protective plus",
          "ring plus protection plan",
          "protect protection plan",
          "protectionm",
          "plans protection plan",
          "protecting plan",
          "protecti",
          "ring protect info",
          "protect plan s",
          "subscribe protect plan",
          "protect plan free",
          "no protect plan needed",
          "ring protect sign up",
          "protective",
          "protect trial",
          "ring protective plus",
          "protect plus pan",
          "protection plan for device",
          "get protection plan",
          "ring protect plan plus",
          "subscribe to protection plan",
          "subscribe to protect plan",
          "extra protection",
          "subscribe protection plan",
          "no protect plan",
          "sign up protection",
          "protect l",
          "ring security protection",
          "protect plus info",
          "security protection plans",
          "protect service",
          "protection plans for ring system",
          "protection setup",
          "ring protection pla",
          "cost of protect",
          "protect subscribe",
          "protect subscribers",
          "protect plus 10 discount",
          "ring protect plu",
          "subscribe ring protect plan",
          "protective ans",
          "subscribe to ring protect plan",
          "protectuon",
          "protect your plan",
          "ring protect videos",
          "need protection plan",
          "activate protection",
          "ring protection plan s",
          "protective plans",
          "protection plus",
          "protecter",
          "ring video protect",
          "ring plan protect",
          "protect your everyday",
          "add camera to protect",
          "protect sub",
          "protection cost",
          "free protect plan",
          "ring protect plus video",
          "protect plus discount",
          "order protection plan",
          "ring protect subscriber",
          "professional protection plan",
          "professional protection",
          "video storage",
          "payment plans",
          "cloud storage",
          "extended warranty",
          "video plans",
          "ring protect basic",
          "payment plan",
          "monthly plan",
          "protection olan",
          "subscribtion",
          "rpp",
          "protect basic plan",
          "basic protect plan",
          "service plan",
          "annual",
          "monthly plans",
          "yearly plan",
          "monthly payments",
          "how to subscribe",
          "ring protect basic plan",
          "protect basic",
          "how to record 24 7",
          "ring account plans",
          "monthly fee",
          "subscribe to video recording",
          "cancel protect plan",
          "subscribe basic plan",
          "how to subscribe my ring",
          "subscribe to the videos from the doorbell",
          "subscribe ring basic",
          "how do i subscribe to a ring protection plan",
          "how to subscribe for the ring",
          "how to subscribe to ring camera",
          "subscribe fees",
          "subscribe for ring doorbell protection plane",
          "i want to subscribe to video recording",
          "i want to subscribe",
          "recording plans",
          "protection plana",
          "renew protection plan",
          "year plan",
          "protec plan",
          "cancel protection plan",
          "plan to allow recording",
          "protect plan purchase",
          "purchase ring protect plan",
          "ring protect basic plan information",
          "basic ring plan",
          "warranty plans",
          "protetionnplans",
          "basic plan coverage",
          "is my plan cancelled",
          "buy plan",
          "how can i purchase record plan",
          "ring video storage plan",
          "protetion plans",
          "cost of protection plan",
          "what plans are available",
          "protetion plan",
          "protectionplans",
          "basic protect plan renew",
          "amazon ring protect plan",
          "plan renewal",
          "ring monthly plan",
          "cost of ring protect basic plan",
          "want to scribe to a plan",
          "proteccion plan",
          "recording plan",
          "standard plan",
          "service planss",
          "premium plan",
          "protaction plan",
          "protect plan support",
          "shop planns",
          "protect ion plan",
          "protec plans",
          "protecion plans",
          "ring video plan",
          "protection plan certificate",
          "pprootect plan",
          "how do i get a plan if i have doorbell",
          "what is ring protect plan",
          "how do i add a plan",
          "to pay for a plan",
          "cost for plan",
          "how to upgrade plan",
          "amazon ring protection plan",
          "add a new plan",
          "ring montiering plans",
          "sign up for protection plans",
          "set up a plan",
          "upgrade plan",
          "plan prices",
          "choose my plann",
          "how much cost the basic protection plan",
          "sign up for 100 00 plan",
          "storage plans",
          "basis plan",
          "recording plans video recording plans",
          "protect planz",
          "how do i pay for ring basic plan",
          "price of ring protect plan",
          "basic protect plan purchase",
          "protect pland",
          "basic plan cost",
          "add another plan",
          "i want to purchase an annual ring plan",
          "proctection plan",
          "add a plan",
          "video recording plan",
          "base plan",
          "yearly video plan",
          "renew plan for video monitoring",
          "cancel the protection plan",
          "protection plan renewal",
          "record plans",
          "cost of plans",
          "how do i add a camera to my protect plan",
          "i want a protection plan",
          "video protect plan",
          "buy protect plan",
          "basic ring doorbell plan",
          "ring recording plan",
          "basic recording plan",
          "renew plan",
          "add protection plan",
          "basic plans",
          "potection plan",
          "protection basic plan",
          "rate plans",
          "device plans",
          "sign up for protection plan",
          "renew my plan",
          "how to pay ring protect basic plan",
          "protextion plan",
          "purchase protection plan",
          "plan protector",
          "how do i enroll in your protection plan",
          "how to get the ring protect plan",
          "ringprotection plan",
          "service plans",
          "how can i purchase the record live plan",
          "protect plane",
          "change plan from monthly to yearly",
          "i want to purchase a ring protect plan",
          "cancel ring plan",
          "protectin plens",
          "add plan",
          "annual plan",
          "ring protection plan to have recordings",
          "protract plans",
          "how long is the video saved in the free plan",
          "buy protection plan",
          "sign up for protect plan",
          "purchase plan",
          "protect planes",
          "product plan",
          "product plans",
          "activate plan",
          "buy a plan",
          "cancel my plan",
          "compare plans",
          "protect plana",
          "purchase basic plan",
          "shop plans",
          "video storage plan",
          "add protect plan",
          "basic protection",
          "cancel ring protect",
          "new plan",
          "protect olan",
          "protect plants",
          "protectplan",
          "protectplans",
          "purchase a plan",
          "ring basic plan",
          "ring doorbell plans",
          "storage plan"
        ]
      },
      {
        value: "/pages/install-my-ring",
        terms: [
          "how to install",
          "install",
          "installation",
          "setup",
          "setup device",
          "set up",
          "set up device",
          "set up a device",
          "ring setup",
          "ring doorbell setup",
          "setup doorbell",
          "setup ring doorbell",
          "ontech"
        ]
      },
      {
        value: mainDomain + "/account/app/my-details",
        terms: ["change password"]
      },
      {
        value: "https://support.ring.com/hc/en-us/articles/360036196372",
        terms: [
          "customer service",
          "customer support",
          "support",
          "help",
          "service",
          "chat",
          "contact information",
          "contact info",
          "contact sales",
          "sales department"
        ]
      },
      {
        value: "https://support.ring.com/hc/en-us/articles/115004666066",
        terms: [
          "remove device",
          "delete",
          "remove",
          "remove a device",
          "delete device",
          "add device",
          "return",
          "returns",
          "return policy",
          "refund",
          "change wifi",
          "change wi fi",
          "change wifi password",
          "certificate",
          "insurance certificate",
          "alarm certificate",
          "insurance",
          "change email",
          "change email address",
          "email",
          "update email",
          "how to change email",
          "update email address",
          "remove email from device",
          "cancel",
          "delete account",
          "cancel account",
          "close account",
          "cancel service",
          "manual",
          "battery life",
          "diode",
          "device health",
          "theft",
          "transfer",
          "reset",
          "permit",
          "faq",
          "technical support",
          "live",
          "live view",
          "view live",
          "live camera",
          "live video",
          "settings",
          "monitoring",
          "monitor",
          "dashboard",
          "record",
          "recording",
          "video recording",
          "modes",
          "add user",
          "trade in",
          "night vision",
          "snooze",
          "register",
          "change address",
          "payment",
          "make payment",
          "make a payment",
          "payments",
          "my plan",
          "my plans",
          "my protection plan",
          "manuals",
          "forgot password",
          "reset wifi",
          "change network",
          "charging cord",
          "update wifi",
          "cellular backup",
          "offline",
          "user manual",
          "people only",
          "people only mode",
          "battery level",
          "reconnect to wifi",
          "alarm permit",
          "installation instructions",
          "how to charge battery",
          "power outage",
          "set up camera",
          "installation manual",
          "trouble shooting",
          "how to remove faceplate"
        ]
      },
      {
        value: "https://support.ring.com/hc/en-us/articles/360036196372",
        terms: [
          "phone number",
          "contact number",
          "customer service phone number",
          "contact phone number",
          "customer service number",
          "telephone number",
          "contact",
          "contact us",
          "support phone number",
          "phone number for support",
          "phone contact",
          "costumer service",
          "phone",
          "ring phone number",
          "phone number for ring",
          "customer service phone",
          "customer support phone number",
          "phone numbers",
          "contact phone",
          "phone number for customer service",
          "phone support",
          "telephone",
          "phone number to call",
          "ring contact number",
          "help phone number",
          "contact numbers",
          "support number",
          "phone number for help",
          "customer service telephone number",
          "phone number customer service",
          "customer service phone numbers",
          "telephone number for ring",
          "customer support number",
          "telephone support",
          "phone number to ring",
          "phone contact number",
          "ring support number",
          "support phone",
          "customer support phone",
          "800 number",
          "phone number to contact ring",
          "toll free number",
          "contact number for ring",
          "phone number contact",
          "support telephone number",
          "ring customer service number",
          "phone number to customer service",
          "phone number to call ring",
          "ring customer support phone number",
          "800 number for ring",
          "tech support number",
          "1800 number",
          "rings phone number",
          "ring support phone number",
          "phone number for ring doorbell",
          "contact phone number for ring"
        ]
      },
      {
        value: "/pages/financing",
        terms: ["affirm plan", "affirm", "financing", "finance"]
      },
      {
        value: "/collections/certified-refurbished",
        terms: ["referbished", "refurbished products"]
      },
      {
        value: "/collections/accessories",
        terms: ["accesories", "accessories"]
      },
      {
        value: "/pages/professional-monitoring",
        terms: ["fire monitoring"]
      },
      {
        value: "https://support.ring.com/hc/en-us",
        terms: ["member plan"]
      },
      {
        value: "/pages/x-line-pro-install-bundles",
        terms: [
          "x line",
          "ring x line",
          "xline",
          "ring x line"
        ]
      },
      {
        value: mainDomain + "/amazon-sidewalk",
        terms: [
          "sidewalk",
          "ring sidewalk",
          "amazon sidewalk"
        ]
      },
      {
        value: "https://support.ring.com/hc/en-us/articles/360050949611-Ring-Video-Doorbell-2nd-Generation-Recall",
        terms: [
          "recall",
          "recalls",
          "recall info",
          "doorbell recall",
          "ring recall",
          "ring doorbell recalls",
          "ring doorbell recall",
          "doorbell recalls",
          "battery recall",
          "recalled ring",
          "ring video doorbell recall",
          "ring 2 recall",
          "recall model",
          "rvd2 recall",
          "ring doorbell 2nd generation recall",
          "recalled ring doorbell",
          "recall on doorbell",
          "recall ring doorbell",
          "recall doorbell",
          "doorbell 2 recall",
          "recalll",
          "recall 2nd generation",
          "recalled models",
          "gen 2 recall",
          "recall on ring",
          "product recalls",
          "recall on ring doorbells",
          "recalled",
          "ring doorbell 2 recall",
          "ring video doorbell 2nd generation recall",
          "product recall",
          "recal",
          "tecall",
          "recall of ring door bell",
          "recalled door bell",
          "recall of ring doorbell",
          "video doorbell 2 recall",
          "recall products",
          "ring gen 2 recall",
          "recall product",
          "recalled doorbells",
          "recall notice",
          "recalled doorbell",
          "2nd gen recall",
          "recall serial numbers",
          "recall ring",
          "recall doorbell 2",
          "video doorbell recall",
          "recall information",
          "recll",
          "ring doorbell fire hazard",
          "what ring door bell is being recalled",
          "ring recalled",
          "recall on door bell",
          "recall ring doorbell 2",
          "recalled video doorbell",
          "camera recall",
          "recall serial number",
          "ring door bell 2 recall",
          "recall of the doorbell",
          "recall models",
          "5um5e5 recall",
          "device recall",
          "generation 2 recall",
          "recall of ring doorbells",
          "is my doorbell recalled",
          "recall on video doorbell",
          "recall devices",
          "recall video doorbell",
          "door bell recalls",
          "recall of doorbell",
          "is there a recall on ring doorbell",
          "is my ring recalled",
          "recall on ring doorbell 2",
          "recall check",
          "ring camera that are being recall",
          "recall s",
          "is our ring doorbell part of the recall",
          "recalled product",
          "doorbell camera recall",
          "has my ring been recalled",
          "how i know if my doorbell is the recall",
          "recalled products",
          "ring video doorbell 2 recall",
          "recall list",
          "any recalls",
          "is my video doorbell being recalled",
          "instructions for recalled",
          "recall doorbells",
          "recall answers",
          "recall doirbells",
          "recall on ring doorbell",
          "product recall serial numbers",
          "is my model number being recalled",
          "what ring devices are being recalled",
          "ring recall fire",
          "recalled door bells",
          "recall of ring",
          "ring doorbell video recall",
          "ring recalls",
          "recall ring model",
          "ring video doorbell 2recall",
          "ring door bell recall",
          "fire recall",
          "recall video doorbell 2",
          "recall instructions",
          "recall on doorbells",
          "door bell recall",
          "recall of ring video doorbell 2",
          "ring video doorbell 3 recall",
          "recall ring 2",
          "recalled ring doorbells",
          "ring recalls video doorbells 2nd generation",
          "recall items",
          "recall of video doorbell 2",
          "safety recall",
          "is my ring doorbell recalled",
          "recall ring door bell",
          "is my ring doorbell being recalled",
          "is the ring pro doorbell being recalled",
          "recakk",
          "recall door bells",
          "was my ring recalled",
          "recall for ring doorbells",
          "which ring bell is recalled",
          "recall item",
          "what model is recalled",
          "recall ring door bells",
          "is ring 2 recalled",
          "ring generation 2 recall",
          "doorbell recall issue",
          "burn fire hazard recall",
          "list of recalled rings",
          "rung doorbell recall",
          "recalled ring door bells",
          "door bell 2 recall",
          "models recalled",
          "recall on certain ring",
          "recall on ring2",
          "check on recalls",
          "is there a recall on the ring doorbell",
          "what doorbells are recalled",
          "ring 2 doorbell recall",
          "recalled doorbell rings",
          "recall of doorbells",
          "2nd generation ring doorbell recall",
          "recall doraville",
          "rvd recall",
          "second generation recall",
          "recall on ring 2",
          "recall on doirbells",
          "is my doorbell in the recall",
          "how to tell if i have a recall",
          "door bell recall 2020",
          "recall details",
          "recall doorbell cameras",
          "rvd 2 recall",
          "recall program",
          "ring doorbell recall second generation",
          "recall on ringdoorbells",
          "ring video doorbell revallrecall",
          "recalled ring doorbell 2",
          "ring door bell recalls",
          "recall 2020",
          "ring recall information",
          "recalled items",
          "recall on cameras",
          "recall second generation",
          "recall door",
          "ring doorbell being recalled",
          "video door bell 2 recall",
          "manufacture dates for recalls",
          "recall ring video doorbell 2",
          "is my door bell recalled",
          "how can i get the recalled security screws",
          "recall on 2nd generation ring doorbells",
          "2nd generation recall",
          "ring pro recall",
          "recall door bell ring",
          "is this recalled sn bhc1lh1931q25212",
          "recall units",
          "recall door bekk",
          "is there a recalls on the ring doorbell",
          "recallall",
          "recalled over fire concerns",
          "recall on ring video doorbell",
          "recall list for vido doorbell",
          "recall on dorbells",
          "ring 2 recalls",
          "recall notices",
          "which ring doorbell is being recalled",
          "recalled number",
          "the ring recall",
          "which ring cameras have been recalled",
          "recalled cameras",
          "ring gwn 2 recall",
          "recall dorbell",
          "serial numbers recall",
          "recall on battery doorbell",
          "ringdoorbell 2 recall",
          "recall of ring 2",
          "where do i find number for recall",
          "recall of video doorbells",
          "recall ribg",
          "list of recall door bells",
          "doorbell 3 plus recall",
          "recall rings",
          "doorbell ring recalls",
          "recall ring2",
          "what ring doorbell had a recall",
          "recall i d",
          "ring 2nd generation recall",
          "what ring doorbell have been recalled",
          "recall modle",
          "recalling",
          "recalled ring products",
          "recallum3e5",
          "generation two recall",
          "second gereration ring recall",
          "ring camera recall",
          "ring doorbell recallrecall",
          "recall informatiion",
          "is there a ring recall",
          "recall option",
          "recall of ring2 doorbell",
          "recall door bell",
          "is my device on recall",
          "doorbell 2 gen recall",
          "doorbell 2nd generation recall",
          "trouble finding recall info",
          "recalled screws",
          "how to check recall",
          "is my doorbell a recalled one",
          "recalled ring units",
          "recall solutions",
          "recall doorbels",
          "recall ring video doorbell",
          "recall numbers",
          "product recall check serial number",
          "recall on my product",
          "doorbell recall info",
          "how to check recall ring bell",
          "video dorbell recall",
          "recall information fi",
          "ring recall model 4v",
          "recall ring doorbells",
          "yrecalls",
          "recall generation 2",
          "recalls door bell",
          "recall one of the products",
          "recalls on ring",
          "ringbell recall",
          "check my ring for recall",
          "recall information for model 8vr1sz sen0",
          "what ring doorbell camera s are recalled",
          "recalldoorbell recalls",
          "i want to know about the recall",
          "recall ring camera serial number",
          "second generation ring recall",
          "recall on battery doubles",
          "recall on ring doorbells that cause fires",
          "ring doorbell camera recall",
          "recall for fire hazard",
          "recalled devices",
          "recalled doorbell 2 ring",
          "recall on doorbell by ring",
          "recalled video ring door bell",
          "which ring bell has a fire recall",
          "recall on ring door bell 2",
          "if my ring doorbell is recalled",
          "recall ring gen2",
          "which products are being recalled",
          "serial number for recall",
          "recall doorbell3",
          "recall for ring doorbell",
          "ring screen recall",
          "recall on ring door bell",
          "is the ring video doorbell pro under recall",
          "recall ring doorrbell",
          "recall gen 2",
          "door camera recall",
          "recalls s",
          "recall fire hazard",
          "2nd gen ring recall",
          "product recalled",
          "recalls the ring peephole doorbell recalled",
          "recallil",
          "which ring is recalled",
          "are ring video doorbell 3 part of the recall",
          "bell recall",
          "recall i",
          "what to do with recalled doorbell",
          "recall of rinh",
          "which ring system was recalled",
          "recallon cameras",
          "video doorbell recalls",
          "ring doorbell2 recall",
          "recall for ring batteries",
          "is the ring pro doorbell one of the recalls",
          "is my ring doorbell on recall list",
          "video 2 recall",
          "recalled doorbells for fire",
          "recalling recall check",
          "recall of ring products",
          "fire recall on ring",
          "recallring doorbell recalls",
          "doorbell recallrecall",
          "current ring video doorbell 2 recalls",
          "the ring that s being recalled",
          "check is my doorbell is on recall list",
          "recall models serial numbers",
          "rvd3 recalls",
          "what ring has been recalled",
          "recall if ring products",
          "information re recall of ring doorbell",
          "ring2 recall",
          "doorbell ring 3 plus recall",
          "recall info 9n ring doorbell",
          "check recall",
          "where to enter serial number for recall",
          "recall policy",
          "recall l",
          "recall model number",
          "recall of ring2",
          "check for my ring recall",
          "how to know if doorbell is recalled",
          "check model number for recall",
          "check for recall",
          "ring fire recall",
          "ring video doorbell recalls",
          "recall for fire hazzard",
          "is there a recall on ring 2nd generation",
          "is there a recall on any of the ring",
          "ring doorbell recall models",
          "recall for fire risk",
          "how do you check recall",
          "ring door recall",
          "recall onring",
          "fire hazard recall",
          "ring camera recalls",
          "5um5e5"
        ]        
      },
      {
        value: mainDomain + "/neighbors",
        terms: [
          "neighbors",
          "neighbors app"
        ]
      },
      {
        value: mainDomain + "/protect-plans",
        terms: [
          "monthly cost",
          "monthly service",
          "monthly costs"
        ]
      },
      { 
        value: mainDomain + "/lennar",
        terms: ["lennar"]
      },
      {
        value: mainDomain + "/jobsite-security",
        terms: [
          "construction site security",
          "jobsite security",
          "job site security",
          "jobsite surveillance",
          "job site surveillance",
          "construction surveillance",
          "home depot product"
        ]
      },
      {
        value: mainDomain + "/security-system",
        terms: [
          "new ring alarm",
          "alarm protects internet",
          "home depot product"
        ]
      },
      {
        value: mainDomain + "/protect-pro",
        terms: [
          "ring protect pro",
          "professional monitoring",
          "call police",
          "24/7 backup internet",
          "extra data",
          "3gb data"
        ]
      },
      {
        value: mainDomain + "/virtual-security-guard-real-time-monitoring",
        terms: [
          "virtual security guard",
          "ring virtual security guard",
          "real time professional monitoring service",
          "virtual monitoring",
          "virtual agent monitoring",
          "virtual guard",
          "virtual security"
        ]
      },
      {
        value: mainDomain + "/virtual-security-guard-real-time-monitoring",
        terms: [
          "virtual security guard",
          "ring virtual security guard",
          "real time professional monitoring service",
          "virtual monitoring",
          "virtual agent monitoring",
          "virtual guard",
          "virtual security"
        ]
      },
      {
        value: mainDomain + "/virtual-security-guard-marketplace",
        terms: [
          "virtual security guard marketplace",
          "marketplace for security monitoring"
        ]
      },
      {
        value: "https://support.ring.com/hc/en-us/articles/4406543921556-Custom-Event-Alerts",
        terms: [
          "custom event alerts",
          "custom alerts",
          "personalized alerts",
          "object detection"
        ]
      },
      {
        value: "https://support.ring.com/hc/en-us/articles/4406543928212-Package-Alerts",
        terms: [
          "package alerts",
          "package detection"
        ]
      },
      {
        value: mainDomain + "/announcements",
        terms: [
          "new devices",
          "new features",
          "new products",
          "new ring devices",
          "new ring features",
          "new ring products",
          "2021 products",
          "new launches",
          "new ring launches"
        ]
      },
      {
        value: mainDomain + "/always-home-cam-flying-camera",
        terms: [
          "drone",
          "always home",
          "always home cam",
          "ring drone",
          "ring always home cam",
          "flying",
          "drone camera",
          "ring always home",
          "always home camera",
          "flying camera",
          "drone cam",
          "fly",
          "security drone",
          "always home drone",
          "drine",
          "autonomous",
          "dron",
          "flying cam",
          "indoor drone",
          "drones",
          "drome",
          "drone security camera",
          "flying drone",
          "ring drone camera",
          "deone",
          "flying indoor camera",
          "drone home",
          "cam drone",
          "home drone",
          "ring always home drone",
          "flying indoor cam",
          "flying ring",
          "dronw",
          "doorbell drone",
          "ddrone",
          "drome camera",
          "camera drone",
          "drone indoor camera",
          "fly cam",
          "autonomously flying",
          "flying indoor",
          "flying security camera",
          "fly camera",
          "ring flying camera",
          "ring security drone",
          "inside drone",
          "secuity drone",
          "autonomous indoor drone security camera",
          "in home drones",
          "house drone",
          "drone camra",
          "always home system with a drone",
          "cam escurrirte drone",
          "ring flying drone",
          "surveillance drone",
          "can drone",
          "new drone camera",
          "ring camera security drone",
          "amazon drone",
          "autonomous drone",
          "new drone",
          "indoor drone security",
          "in home drone",
          "drone security",
          "always home drone camera",
          "alexa drone",
          "ting drone",
          "amazon security drone",
          "home drone security",
          "always home camera drone",
          "ring indoor drone",
          "home security drone",
          "drone in",
          "interior drone",
          "drone cm",
          "ring drones",
          "cam security drone",
          "alarm system with drone",
          "webcam drone",
          "drone drone",
          "drone vigilant",
          "autonomously flying indoor security camera",
          "flying security",
          "fly indoor",
          "flying cam price",
          "flying indoor security cam",
          "flyinf",
          "flying security cameras",
          "flying device",
          "always home flying cam",
          "autonomously flying indoor camera",
          "flying centre",
          "flying can",
          "flying ring camera",
          "ring s crazy flying security cam",
          "ring drone cam",
          "ring home security drone",
          "security drones",
          "nw inndoor drone",
          "new inndoor drone",
          "indoor flying security camera",
          "flying indoor security camera",
          "drone box",
          "drone ring",
          "flying drone camera",
          "flying security cam",
          "always home ring",
          "always home can",
          "autonomous security drone"
        ]
      }
    ],
    typos: [
      {
        value: "doorbell",
        terms: [
          "door bell",
          "door bells",
          "door bell camera",
          "ring door bell camera",
          "ring door bell",
          "bell",
          "video door bell",
          "ring bell",
          "doirbell",
          "door bell cam",
          "doorview cam",
          "ring video door bell"
        ]
      },
      {
        value: "doorbell with chime",
        terms: [
          "8vraxz sen0",
          "door bell with chime",
          "wireless doorbell with chime"
        ]
      },
      {
        value: "floodlight",
        terms: [
          "flood light",
          "flood lights",
          "flood light camera",
          "flood light cam",
          "floodlight can",
          "ring flood light",
          "flood camera",
          "flood light cameras",
          "flood cam",
          "ring flood lights",
          "flood loght",
          "flood light wired",
          "wired flood light"
        ]
      },
      {
        value: "floodlight battery",
        terms: [
          "wireless floodlight",
          "flood light battery",
          "battery flood light",
          "floodlight wireless",
          "wireless floodlights"
        ]
      },
      {
        value: "floodlight cam",
        terms: [
          "flood light with camera",
          "ring flood light camera",
          "floodcam",
          "ring flood light cam",
          "camera flood light",
          "flood cameras",
          "floodlight canera",
          "flood light camara"
        ]
      },
      {
        value: "wifi extender",
        terms: [
          "wifi booster",
          "booster",
          "signal booster",
          "wi fi booster",
          "wi fi extender"
        ]
      },
      {value: "garage", terms: ["myq g0402", "my q"]},
      {
        value: "hardwired",
        terms: ["hard wired", "hard wire", "hard wired ring", "ring hard wired", "hard wire", "hard wire ring"]
      },
      {
        value: "hardwired camera",
        terms: [
          "hard wired camera",
          "spotlight camera hard wired",
          "spotlight cam hard wired",
          "hard wire camera",
          "hard wired cameras",
          "hard wired spotlight cam",
          "hard wired spotlight camera",
          "hard wire camaras",
          "hard wired flood light",
          "hard wired outdoor camera",
        ]
      },
      {
        value: "hardwired doorbell",
        terms: [
          "hard wired doorbell",
          "hard wired door bell",
          "hardwired door bell",
          "hard wire doorbell",
          "hard wired ring doorbell",
          "hard wire door bell",
          "hard wire ring doorbell",
          "hard wired doorbells",
          "hard wired video doorbell",
          "doorbell hard wire",
        ]
      },
      { value: "hardwired kit", terms: ["hard wire kit", "hard wired kit"]},
      { value: "hardwired transformer", terms: ["hard wire transformer"]},
      {
        value: "indoor cam",
        terms: ["mini", "mini camera", "indoor camara", "inside camara", "minicamara"]
      },
      {
        value: "spotlight",
        terms: [
          "spot light",
          "ring spot light",
          "spot lights",
          "solar spot light",
          "spot light cam wired",
          "spot light cam mount",
          "spot light cameras",
          "spot light wired",
          "ring spot light camera",
          "solar spot light cam",
          "spot light camera battery",
          "battery spot light",
          "ring spot light cam",
          "hardwired spot light",
          "spot light mount",
          "wired spot light cam",
          "wireless spot light",
          "spot lights"
        ]
      },
      {
        value: "spotlight cam",
        terms: ["spot light cam",
          "spot light cam battery",
          "spot light camera",
          "spot cam",
          "spot camera",
          "spotlight camara"
        ]
      },
      {
        value: "cam battery",
        terms: [
          "wireless camera",
          "wireless cameras",
          "outdoor wireless camera"
        ]
      },
      { value: "keypad", terms: ["key pad", "key pads"] },
      { value: "retrofit alarm kit", terms: ["retro fit alarm kit", "retro alarm kit"]},
      { value: "retrofit kit", terms: ["retro alarm", "retro fit alarm"]},
      {
        value: "spare parts",
        terms: ["replacement parts", "replacement screws"]
      },
      {
        value: "sensor",
        terms: ["censor", "censors", "senors"]
      },
      {
        value: "quick release battery pack",
        terms: [
          "replacement battery",
          "battery replacement",
          "replacement batteries",
          "back up battery"
        ]
      },
      { value: "peephole cam", terms: ["peephole camera", "peep hole", "peep hole camera"] },
      {
        value: "stick up cam",
        terms: [
          "stickup",
          "stickup cam",
          "stickup camera",
          "stick up cam classic",
          "stick up cam 3rd gen",
          "stick up cam classic v2",
          "stick up camara"
        ]
      },
      {value: "stick up cam elite", terms: ["stickup cam elite"]},
      {
        value: "stick up cam battery",
        terms: [
          "stickup cam battery",
          "wireless indoor camera",
          "wireless indoor cam",
          "wireless indoor cameras",
          "indoor wireless camera",
          "indoor wireless cameras",
          "ring stick up cam battery 3rd gen",
          "stick up cam wireless",
          "wireless indoor",
          "wireless stick up cam",
          "indoor cam wireless",
          "indoor wireless"
        ]
      },
      {
        value: "stick up cam solar",
        terms: [
          "stickup cam solar",
          "solar stickup",
          "stickup camera solar"
        ]
      },
      {
        value: "steplight",
        terms: [
          "step light",
          "step lights",
          "solar step light",
          "ring step light",
          "solar step lights",
          "step lighting",
          "step light solar"
        ]
      },
      {
        value: "doorbell pro",
        terms: ["ring door bell pro", "video door bell pro"]
      },
      {
        value: "video doorbell 2020",
        terms: [
          "8vrasz sen0"
        ]
      },
      {
        value: "video doorbell 3",
        terms: [
          "door bell 3",
          "video door bell 3",
          "doorbell v3",
          "rvd 3",
          "rvd3",
          "ring video door bell 3"
        ]
      },
      {
        value: "video doorbell 3 plus",
        terms: [
          "door bell 3 plus",
          "doorbell 3plus",
          "ring door bell 3 plus",
          "rvd 3 plus"
        ]
      },
      {
        value: "video doorbell pro",
        terms: [
          "door bell pro",
          "88lp000ch000",
          "ring video door bell pro",
          "ring pro v3",
          "ringpro",
          "ring pro door bell",
          "rvd pro",
          "video dorbell pro"
        ]
      },
      { value: "wedge kit", terms: ["corner wedge"]},
      {
        value: "wifi extender",
        terms: [
          "wifi range extender",
          "wifi extension",
          "internet booster"
        ]
      },
      { value: "window security stickers", terms: ["decal"]},
      { value: "z wave", terms: ["zwave"]},
      { value: "adapter", terms: ["ac adapter"] },
      {
        value: "chime",
        terms: [
          "door bell chime",
          "chine",
          "chines",
          "chrime",
          "ring chine",
          "ring chim pro",
          "indoor chime",
          "shime",
          "wireless chime",
          "chime box",
          "hime",
          "wireless chimes"
        ]
      },
      { value: "pathlight", terms: ["path light"] },
      { value: "smoke", terms: ["fire alarm", "fire"] },
      {
        value: "smoke and co",
        terms: [
          "co2",
          "fire detector",
          "co2 detector",
          "co2 listener",
          "co2 sensor",
          "co2 alarm",
          "smoke co2",
          "smoke and co2",
          "co2 sensors",
          "co2 listening",
          "fire and co2",
          "smoke detector co2"
        ]
      },
      { value: "smart lighting battery", terms: ["wireless security light"] },
      { value: "flood sensor", terms: ["water detector", "leak detector", "flood detector"] },
      { value: "adapter", terms: ["power cord"] },
      {
        value: "camera",
        terms: [
          "outdoor",
          "outdoor camera",
          "outdoor cameras",
          "outdoor cam",
          "out door camera",
          "camara",
          "outdoor camara",
          "camra",
          "exterior camera",
          "canera",
          "ring camara",
          "outdoor camaras",
          "outside camaras"
        ]
      },
      {value: "cameras", terms: ["camaras"]},
      {
        value: "camera battery",
        terms: [
          "wireless outdoor camera",
          "wireless cam",
          "wireless security camera",
          "wireless outdoor",
          "wireless outdoor cameras",
          "outdoor wireless cameras",
          "camera wireless",
          "wireless security cameras",
          "wireless ring camera",
          "wireless outdoor cam",
          "wireless camaras",
          "wireless outdoor security camera",
          "wireless video",
          "outdoor camera wireless",
          "outdoor cameras wireless",
          "camera wireless",
          "wireless security cameras",
          "wireless ring camera",
          "wireless outdoor cam",
          "wireless camaras",
          "wireless outdoor security camera",
          "wireless video",
          "outdoor camera wireless",
          "outdoor cameras wireless",
          "ring outdoor wireless camera",
          "ring wireless camera",
          "wireless outside cameras",
          "wireless security cam",
          "wireless video cam"
        ]
      },
      {
        value: "lock",
        terms: ["door lock", "door locks", "deadbolt", "dead bolt", "dead bolt lock", "dead bolts"]
      },
      { value: "locks", terms: ["keyless entry", "doorlock"] },
      { value: "bridge", terms: ["hub"] },
      { value: "power", terms: ["power supply"] },
      { value: "pro power kit", terms: ["pro power kit v2", "ring pro power kit v2", "v2 pro power kit"]},
      {
        value: "mailbox",
        terms: [
          "mail box",
          "mail box sensor",
          "mail box senor",
          "mailbox alarm",
          "mail box alarm",
          "mail box camera",
          "mail box ring",
          "mail box sensors",
          "mail box",
          "mail box cam",
          "mail box notifier",
          "ring mail box",
          "mail box cameras",
          "mail box detector",
          "mail box motion sensor",
          "mail box notify",
          "mail box senser"
        ]
      },
      {
        value: "pathlight",
        terms: [
          "path light",
          "path lights",
          "solar path light",
          "solar path lights",
          "path light solar",
          "path lighting",
          "path light battery",
          "ring solar path lights",
          "path light stake",
          "ring path light",
          "ring path lights",
          "ring solar path light",
          "smart path lights",
          "smart path light",
          "solar powered path lights",
          "4 pack solar path light",
          "4 pack solar path lights",
          "4 path lights"
        ]
      },
      { value: "solar doorbell", terms: ["solar door bell"] },
      {
        value: "faceplate",
        terms: [
          "face plate",
          "faceplate cover for ring doorbell",
          "removable faceplate for video door bell 2",
          "interchangable faceplate 1st generation",
          "bronze faceplate fordoorbell pro",
          "pro faceplate black v3",
          "faceplate extention",
          "faceplate cocers",
          "interchangeable face plate"
        ]
      },
      { value: "faceplates", terms: ["face plates"]},
      { value: "faceplate video doorbell 3", terms: ["ring 3 face plate", "doorbell 3 face plate"]},
      { value: "pro faceplate", terms: ["ring pro plate"]},
      { value: "everyday pro bundle", terms: ["everyday pro kit"]},
      { value: "eero", terms: ["erro"] },
      { value: "solar floodlight", terms: ["solar flood light"] },
      { value: "peephole", terms: ["peehole"] },
      {
        value: "peephole cam",
        terms: [
          "peephole camera",
          "peep hole",
          "peep hole camera",
          "peep hole cam",
          "ring peep hole",
          "peep hole ring",
          "peepcam",
          "peephole cam cover"
        ]
      },
      {
        value: "spotlight cam battery",
        terms: [
          "spot light battery",
          "wireless floodlight camera",
          "wireless spotlight cam",
          "spotlight cam wireless",
          "spotlight wireless",
          "wireless floodlight cam",
          "wireless spotlight",
          "wireless flood light",
          "wireless flood lights",
          "wireless spotlight camera",
          "spotlight wireless outdoor security camera",
          "floodlight cam wireless",
          "wireless flood light camera"
        ]
      },
      { value: "spotlight cam solar",
        terms: [
            "spot light cam solar"
        ]
      },
      {
        value: "spotlight solar",
        terms: [
          "spot light solar",
          "spot light cam with solar",
          "spot light with solar panel",
          "spot light camera with solar panel",
          "spot light camera solar",
          "solar spot light camera",
          "solar spot lights",
          "spot light camera with solar",
          "spot light solar cam",
          "spot light cam and solar panel"
        ]
      },
      { value: "solar charger", terms: ["solor charger"] },
      {
        value: "chime pro",
        terms: [
          "chim pro",
          "chimepro",
          "chrime pro",
          "chine pro",
          "ring chime pro wi fi extender",
          "charm pro",
          "chime pro 2nd generation",
          "chime pro v2",
          "ring bell pro",
          "ring chimepro",
          "chime pro wi fi extender",
          "chime pro 1",
          "chimpro",
          "ring chime pro 2nd gen",
          "ring chrome pro"
        ]
      },
      { value: "contact sensor", terms: ["contact censor"]},
      { value: "corner kit", terms: ["corner wedge kit"]},
      {
        value: "solar",
        terms: [
          "solor",
          "solar adapter",
          "solar charger for camera",
          "solar panel cable",
          "solar panel adapter",
          "camera solar charger",
          "solar panel cord",
          "solar panel extension cord",
          "solar camara",
          "solar cell",
          "solar extension",
          "solar pad",
          "stick up cam solar charger",
          "solar cord",
          "solar camaras",
          "solar canera"
        ]
      },
      {
        value: "solar charger",
        terms: [
          "door bell solar",
          "door bell solar charger",
          "solar chager",
          "solar charger first generation",
          "solar cover",
          "solar ring door bell",
          "solar charger door bell",
          "ring door bell solar charger",
          "solar charger for door bell",
          "solar panel for door bell",
          "solar powered door bell",
          "solarcharger",
          "solar for door bell",
          "solar chatger"
        ]
      },
      {
        value: "solar floodlight",
        terms: [
          "solar flood lights",
          "flood light solar",
          "solar flood light camera",
          "solar flood cam",
          "solar flood light cam",
          "flood solar",
          "floodlight camera with solar panel",
          "flood light cam solar",
          "flood light with solar",
          "solar powered flood light",
          "flood light camera with solar panel",
          "floodlight with solar panel",
          "floodlight solar panel",
          "ring solar flood light",
          "solar powered flood lights"
        ]
      },
      {
        value: "solar panel",
        terms: [
          "solar pannel",
          "solor panel",
          "solar panal",
          "solar oanel",
          "solarpanel",
          "solar pannels",
          "solar plate",
          "door bell solar panel",
          "solar panrl",
          "solar pnel",
          "solar panel parts",
          "solar panle",
          "solar panel for stickup cam",
          "spotlight cam solar charger",
          "large solar panel",
          "solar pamel"
        ]
      },
      { value: "14 piece", terms: ["14 pc"]},
      { value: "alarm security kit", terms: ["ring 10 piece wireless security alarm kit"]},
      { value: "battery", terms: ["batery", "bettery", "baterry", "bateries"]},
      {
        value: "battery doorbell",
        terms: [
          "wireless door bell",
          "door bell battery",
          "battery operated doorbell",
          "wireless doorbells",
          "battery door bell",
          "wireless doorbell camera",
          "doorbell wireless",
          "ring wireless doorbell",
          "ring doorbell wireless",
          "wireless door bell camera",
          "wireless door ring",
          "wireless ring doorbells",
          "wireless video doorbells"]
      },
      { value: "bulb", terms: ["lightbulb", "lightbulbs", "par 38", "smart lightbulb", "smart lightbulbs"]},
      {
        value: "glass break sensor",
        terms: [
          "glass break",
          "glass"
        ]
      }
    ]
  };

  var formInput;
  var form;

  function init() {
    //locate dom elements
    form = document.getElementById("SearchForm");
    formInput = document.getElementById("SearchInput");

    //add event listener to override enter key on search
    formInput.addEventListener("keydown", event => {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopPropagation();
        handleSubmit();
      }
    });

    handleProductUrls();
  }

  function handleProductUrls() {
    var host = window.location.host;
    
    //skip if shopify is au/nz
    if(!host.match(/(nz|au)/ig)) {

      //detect env
      var destination = host.match(/(dev|staging)/ig) ? 'https://www.dev.ring.com' :
        host.match(/(qa)/ig) ? 'https://www.qa.ring.com' : 'https://ring.com';

      //update urls
      var products = document.querySelectorAll('.products .product a');
      if(products) {
        for(var i = 0; i < products.length; i++) {
          var product = products[i];
          var url = product.getAttribute('href');
          const match = url && url.match(/\/products\/.+?$/i);
          if(match) {
            product.setAttribute('href', destination + match);
          }
        }
      }
    }
  }

  function handleSubmit() {
    //normalize input
    var inputValue = formInput.value.trim().toLowerCase();

    //search for term in config
    var handler;
    if ((handler = searchTermInType("typos", inputValue))) {
      //handle typo
      formInput.value = handler.value;
      form.submit();
    } else if ((handler = searchTermInType("redirections", inputValue))) {
      //handle redirect
      window.location = handler.value;
    } else {
      //no handler found
      form.submit();
    }
  }

  function searchTermInType(type, term) {
    for (var i in CONFIG[type]) {
      if (CONFIG[type][i].terms.indexOf(term) >= 0) return CONFIG[type][i];
    }

    return undefined;
  }

  var loaded = document.readyState !== "loading";
  if (loaded) {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();
